module.exports = __webpack_public_path__ + "static/media/pattern-houses.a1e0dba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern-houses.png
// module id = 294
// module chunks = 0